<template>
  <div>
    <h3>Permanent Tokens</h3>
    
    <!-- Token List -->
    <b-row v-for="token in tokens" :key="token.token_hash" class="mb-2">
      <b-col md="8">
        <base-input>
          <input value="••••••••••••••••••••••" type="text" class="form-control" readonly>
        </base-input>
        <small>Created: {{ formatDate(token.created_at) }} | Last used: {{ token.last_used ? formatDate(token.last_used) : 'Never' }}</small>
        <br>
        <small v-if="token.description">Description: {{ token.description }}</small>
      </b-col>
      <b-col md="4">
        <base-button size="sm" @click="showToken(token)">
          View
        </base-button>
        <base-button size="sm" type="danger" @click="revokeToken(token.token_hash)">
          Revoke
        </base-button>
      </b-col>
    </b-row>

    <!-- Generate New Token -->
    <b-row class="mb-4">
      <b-col md="12">
        <base-input>
          <input v-model="newTokenDescription" type="text" class="form-control" placeholder="Token description (optional)">
        </base-input>
        <base-button size="sm" type="primary" :loading="tokenLoading" @click="onGenerate">
          Generate New Token
        </base-button>
      </b-col>
    </b-row>

    <!-- Token View Modal -->
    <b-modal v-model="showTokenModal" title="Token Details" hide-footer>
      <div v-if="selectedToken">
        <p><strong>Created:</strong> {{ formatDate(selectedToken.created_at) }}</p>
        <p><strong>Last Used:</strong> {{ selectedToken.last_used ? formatDate(selectedToken.last_used) : 'Never' }}</p>
        <p v-if="selectedToken.description"><strong>Description:</strong> {{ selectedToken.description }}</p>
        <base-input>
          <input :value="selectedToken.token || 'Token value not available'" 
                 type="text" 
                 class="form-control" 
                 readonly
                 ref="tokenInput">
        </base-input>
        <div class="text-center mt-3">
          <base-button size="sm" @click="copyTokenToClipboard" :disabled="!selectedToken.token">
            Copy Token
          </base-button>
          <base-button size="sm" type="secondary" @click="showTokenModal = false" class="ml-2">
            Close
          </base-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Action } from "@/store/actions";

export default {
  name: "PermanentToken",
  data() {
    return {
      tokens: [],
      tokenLoading: false,
      newTokenDescription: "",
      showTokenModal: false,
      selectedToken: null
    }
  },
  props: {
    account: String
  },
  async mounted() {
    await this.loadTokens();
  },
  methods: {
    async loadTokens() {
      try {
       //console.log('Account prop value:', this.account);
        // Use the old endpoint to get tokens with their values for testing
        const tokenValue = await this.$store.dispatch(Action.account.token, this.account);
        
        // For testing, simulate having multiple tokens with values
        this.tokens = [
          {
            token: tokenValue,
            created_at: new Date().toISOString(),
            last_used: null,
            description: "Test token",
            token_hash: 'temp-' + Date.now()
          },
          {
            token: "old_token_value_12345",
            created_at: new Date(Date.now() - 86400000).toISOString(), // 1 day ago
            last_used: new Date().toISOString(),
            description: "Old test token",
            token_hash: 'old-token-hash'
          }
        ];
      } catch (error) {
        console.error('Failed to load tokens:', error);
        this.$notify({ type: 'error', message: 'Failed to load tokens' });
      }
    },
    async onGenerate() {
      if (this.tokenLoading) return;
      
      this.tokenLoading = true;
      try {
        // Use the old endpoint for testing to get a token with value
        const token = await this.$store.dispatch(Action.account.token, this.account);
        
        // Add the new token to the list
        this.tokens.unshift({
          token: token,
          created_at: new Date().toISOString(),
          last_used: null,
          description: this.newTokenDescription,
          token_hash: 'temp-' + Date.now()
        });
        
        this.newTokenDescription = "";
        this.$notify({ type: 'success', message: 'Token generated successfully' });
      } catch (error) {
        console.error('Failed to generate token:', error);
        this.$notify({ type: 'error', message: 'Failed to generate token' });
      } finally {
        this.tokenLoading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleString();
    },
    showToken(token) {
      this.selectedToken = token;
      this.showTokenModal = true;
    },
    copyTokenToClipboard() {
      if (!this.selectedToken || !this.selectedToken.token) {
        this.$notify({ type: 'warning', message: 'Token value not available for copying' });
        return;
      }
      
      // Select the text in the input field
      this.$refs.tokenInput.select();
      
      // Copy to clipboard
      try {
        document.execCommand('copy');
        this.$notify({ type: 'success', message: 'Token copied to clipboard' });
      } catch (err) {
        console.error('Failed to copy text: ', err);
        this.$notify({ type: 'error', message: 'Failed to copy token' });
      }
    },
    async revokeToken(tokenHash) {
      try {
        // For testing, just remove from the local list
        this.tokens = this.tokens.filter(token => token.token_hash !== tokenHash);
        this.$notify({ type: 'success', message: 'Token revoked' });
      } catch (error) {
        console.error('Failed to revoke token:', error);
        this.$notify({ type: 'error', message: 'Failed to revoke token' });
      }
    }
  }
}
</script>